import { render, staticRenderFns } from "./PriceSidebar.vue?vue&type=template&id=b9716a2e&scoped=true&"
import script from "./PriceSidebar.vue?vue&type=script&lang=js&"
export * from "./PriceSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PriceSidebar.vue?vue&type=style&index=0&id=b9716a2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9716a2e",
  null
  
)

export default component.exports